import { Component } from '@angular/core';

@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.scss']
})
export class AlertsComponent {

  header?: string;
  text?: string;
  showAlerts?: boolean;
  font_color?: string;
  background?: string;
  define_interval?: boolean;
  show_item?: boolean;
  interval_time?: { start: string; end: string };
  slider_time_range?: [number, number];

  

}
